import { render, staticRenderFns } from "./MoneyMovements.vue?vue&type=template&id=e0864f18"
import script from "./MoneyMovements.vue?vue&type=script&lang=js"
export * from "./MoneyMovements.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports